function toggleAccordion() {
  const accordion = this.closest('[js-accordion]');
  const content = accordion.querySelector('[js-accordion-content]');
  const body = accordion.querySelector('[js-accordion-body]');
  const isOpen = accordion.classList.contains('open');

  if (!isOpen) {
    const bodyHeight = body.offsetHeight;
    accordion.classList.add('open');
    content.style.height = `${bodyHeight}px`;
  } else {
    accordion.classList.remove('open');
    content.style.height = 0;
  }
}

function setHeight() {
  setTimeout(() => {
    const openedAccordions = document.querySelectorAll('.open[js-accordion]');

    Array.prototype.forEach.call(openedAccordions, accordion => {
      const content = accordion.querySelector('[js-accordion-content]');
      const body = accordion.querySelector('[js-accordion-body]');
      const bodyHeight = body.offsetHeight;
      content.style.height = `${bodyHeight}px`;
    });
  }, 500);
}

const eventHandler = () => {
  const accordionHeader = document.querySelectorAll('[js-accordion-header]');
  Array.prototype.forEach.call(accordionHeader, header => {
    header.addEventListener('click', toggleAccordion, false);
  });

  window.addEventListener('resize', setHeight);
  window.addEventListener('orientationchange', setHeight);
};

const accordion = async () => eventHandler();

export default accordion;
